const GENDER_TO_CIVILITY_MAP = {
  homme: 'M',
  femme: 'Mme',
};

const DEFAULT_BIRTH_DATE = { day: '', month: '', year: '' };

const formatDateComponent = (value, length = 2) =>
  value?.slice(0, length).padStart(length, '0') || '';

const parseIsoDate = (dateString) => {
  const dateParts = dateString.split('-');
  if (dateParts.length !== 3 || dateParts[0].length !== 4) {
    return null;
  }

  const [year, month, day] = dateParts;
  return {
    day: formatDateComponent(day),
    month: formatDateComponent(month),
    year: formatDateComponent(year, 4)
  };
};

const parseSlashDate = (dateString) => {
  const dateParts = dateString.split('/');
  if (dateParts.length !== 3) {
    return null;
  }

  const [day, month, year] = dateParts;
  return {
    day: formatDateComponent(day),
    month: formatDateComponent(month),
    year: formatDateComponent(year, 4)
  };
};

const parseNativeDate = (date) => ({
  day: date.getDate().toString().padStart(2, '0'),
  month: (date.getMonth() + 1).toString().padStart(2, '0'),
  year: date.getFullYear().toString()
});

export const getInitialFullName = (user) => {
  if (!user?.nom) return '';
  if (!user?.prenom) return '';

  return `${user.nom} ${user.prenom}`;
};

export const getInitialCivility = (user) => {
  if (!user?.gender) return '';

  const normalizedGender = user.gender.toLowerCase().trim();
  return GENDER_TO_CIVILITY_MAP[normalizedGender] || '';
};

export const getInitialBirthDate = (user) => {
  if (!user?.birthDate) return DEFAULT_BIRTH_DATE;

  try {
    const dateString = user.birthDate.toString();

    if (user.birthDate instanceof Date) {
      return parseNativeDate(user.birthDate);
    }

    if (dateString.includes('-')) {
      return parseIsoDate(dateString) || DEFAULT_BIRTH_DATE;
    }

    if (dateString.includes('/')) {
      return parseSlashDate(dateString) || DEFAULT_BIRTH_DATE;
    }

    return DEFAULT_BIRTH_DATE;
  } catch (error) {
    console.warn('Birth date parsing failed:', error);
    return DEFAULT_BIRTH_DATE;
  }
};

export const getInitialEmail = (user) => user?.email?.trim() || '';

export const getInitialPhone = (user) => user?.phoneNumber?.trim() || '';

export const initializeFormData = (user) => ({
  fullName: getInitialFullName(user),
  civility: getInitialCivility(user),
  birthDate: getInitialBirthDate(user),
  email: getInitialEmail(user),
  phone: getInitialPhone(user),
  store: '',
  emailOptin: false,
  smsOptin: false,
});